import { Box, Text } from "@chakra-ui/react";
import { DashboardDataSelect, type DashboardDataSelectProps } from "./DashboardDataSelect";

export type DashboardSelectFieldProps = {
  label: string;
  /** Use with `label` as `Text as="label" htmlFor={selectId}` for accessibility. */
  selectId?: string;
} & DashboardDataSelectProps;

export function DashboardSelectField({ label, selectId, ...selectProps }: DashboardSelectFieldProps) {
  return (
    <Box w="100%">
      <Text
        as="label"
        htmlFor={selectId}
        fontSize="xs"
        fontWeight="medium"
        color="gray.500"
        mb={1}
        display="block"
      >
        {label}
      </Text>
      <DashboardDataSelect {...selectProps} triggerId={selectId} />
    </Box>
  );
}
